import { render, staticRenderFns } from "./NovaPoshtaEditing.vue?vue&type=template&id=16912c66&scoped=true"
import script from "./NovaPoshtaEditing.vue?vue&type=script&lang=js"
export * from "./NovaPoshtaEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16912c66",
  null
  
)

export default component.exports